/** work-around for making standalone builds work in older versions of Nx **/
/** TODO: Remove this when we upgrade to Nx 16.3.0+ **/
import path from 'path'
path.resolve(__dirname, '../next.config.js')

import {
  CarCarePageContent,
  PageProps,
  VapsHero,
  getStoryBySlug,
  useStoryblokState,
} from '@cinch-nx/data-storyblok'
import { VapsFeatureCarCare } from '@in-life-and-loyalty/vaps-feature-car-care'
import { Head } from '@in-life-and-loyalty/vaps-ui'
import type { GetStaticProps } from 'next'

function CarCarePage({
  story,
  preview,
  generatedAt,
}: PageProps<CarCarePageContent>) {
  const { content, slug } = useStoryblokState<CarCarePageContent>({
    story,
    enableBridge: preview,
  })
  const SEO = content?.SEO?.[0]
  return (
    <>
      <Head
        {...SEO}
        generatedAt={generatedAt}
        fallbackTitle={slug}
        fallbackDescription={'CarCare.'}
      />
      {content && <VapsFeatureCarCare content={content} />}
    </>
  )
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export const getStaticProps: GetStaticProps = async ({ preview = false }) => {
  try {
    const story = await getStoryBySlug<CarCarePageContent>(`car-care/index`, {
      cv: Date.now(),
      version: preview ? 'draft' : 'published',
    })

    const HeroProps: VapsHero = story.content?.hero[0]

    return {
      props: {
        story,
        preview,
        generatedAt: Date.now(),
        layoutProps: {
          heroProps: HeroProps,
          showBorderRadius: true,
          showFooterBorderRadius: false,
        },
      },
      revalidate: 60, // In seconds
    }
  } catch {
    return { notFound: true } as const
  }
}

export default CarCarePage
